
if (!customElements.get('custom-cart-popup')) {
  class CustomCartPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.querySelectorAll('[data-type="close"]').forEach(item => {
        item.addEventListener('click', this.close.bind(this));
        item.addEventListener('keydown', e => {
          if (e.key === 'Enter') this.close();
        });
      });

      this.setTimeoutRunning = false;
      this.popupDuration = this.dataset.duration
        ? parseInt(this.dataset.duration, 10) * 1000
        : 10000;

      this.adjustTopPosition();
      window.addEventListener('scroll', () => {
        this.adjustTopPosition();
      });
    }

    refresh() {
      this.init();
    }

    adjustTopPosition() {
      const header = document.querySelector('custom-header');
      const announcementBar = document.querySelector(
        'custom-announcement-bar'
      );

      if (header) {
        let headerHeight = header.offsetHeight;

        if (header.dataset.scroll !== 'true' && announcementBar) {
          headerHeight += announcementBar.offsetHeight;
        }

        this.style.top = `${headerHeight}px`;
      }
    }

    formatPopupMoney(cents) {
      if (
        typeof Shopify !== 'undefined' &&
        typeof Shopify.formatMoney === 'function'
      ) {
        return Shopify.formatMoney(cents);
      }

      return `$${(cents / 100).toFixed(2)}`;
    }

    // Wine classifications that should not be displayed.
    isAlcoholValue(value) {
      return [
        'not over 16%',
        '16-21%',
        '21-24%',
        'sparkling wine',
        'carbonated wine'
      ].includes(String(value || '').trim().toLowerCase());
    }

    getDisplayOptions(product) {
      if (Array.isArray(product.options_with_values)) {
        return product.options_with_values
          .filter(option =>
            String(option.name || '').trim().toLowerCase()
              !== 'alcohol content'
          )
          .map(option => option.value)
          .filter(value =>
            value &&
            value !== 'Default Title'
          );
      }

      const options = Array.isArray(product.variant_options)
        ? product.variant_options
        : [];

      return options.filter(value =>
        value &&
        value !== 'Default Title' &&
        !this.isAlcoholValue(value)
      );
    }

    getDisplayTitle(product) {
      let title =
        product.product_title ||
        product.title ||
        product.name ||
        'Item added to cart';

      // Shopify cart item titles may include the variant.
      // Prefer the actual product title when available.
      if (!product.product_title) {
        title = title.replace(
          /\s*-\s*(Not over 16%|16-21%|21-24%|Sparkling Wine|Carbonated Wine)$/i,
          ''
        );
      }

      return title;
    }

    renderContent(product) {
        console.log('POPUP PRODUCT DATA:', product);
      const template = this.querySelector('template');
      if (!template) return;

      const clone = template.content.cloneNode(true);
      this.previouslyFocusedElement = document.activeElement;

      if (
        product &&
        Array.isArray(product.items) &&
        product.items.length > 0
      ) {
        product = product.items[0];
      }

      if (product) {
        const productImage =
          product.image ||
          (product.featured_image && product.featured_image.url) ||
          product.featured_image ||
          '';

        const productTitle = this.getDisplayTitle(product);
        const productUrl =
          product.url || product.product_url || '#';

        const image = clone.querySelector('.cart-item__image img');

        if (productImage && image) {
          image.setAttribute('src', productImage);
        }

        clone.querySelectorAll('.cart-item a').forEach(item => {
          item.setAttribute('href', productUrl);
          item.setAttribute('title', productTitle);
        });

        const heading = clone.querySelector('.heading');

        if (heading) {
          heading.textContent = productTitle;
        }

        const vendor = clone.querySelector('.vendor');

        if (vendor) {
          vendor.textContent = product.vendor || '';
        }

        // Preserve apparel sizes and colors.
        // Remove wine alcohol classifications.
        const variantElement = clone.querySelector('.variant');

        if (variantElement) {
          const displayOptions = this.getDisplayOptions(product);
          const variantText = displayOptions.join(', ');

          if (variantText) {
            variantElement.textContent = variantText;
            variantElement.style.display = '';
          } else {
            variantElement.textContent = '';
            variantElement.style.display = 'none';
          }
        }

        const quantity = clone.querySelector('.quantity');

        if (quantity) {
          quantity.textContent = `Qty: ${product.quantity || 1}`;
        }

        const price = clone.querySelector('.price');

        if (price) {
          const productPrice =
            product.final_price ??
            product.final_line_price ??
            product.price ??
            product.line_price ??
            0;

          price.textContent = this.formatPopupMoney(productPrice);
        }

        const recipientElement = clone.querySelector('.recipient');

        if (recipientElement && product.properties) {
          const recipient = [];

          for (const key in product.properties) {
            const value = product.properties[key];

            if (
              ['Recipient email', 'Recipient name', 'Message'].includes(key) &&
              value !== ''
            ) {
              recipient.push(`${key}: ${value}`);
            }
          }

          if (recipient.length) {
            recipientElement.textContent = recipient.join(', \n');
            recipientElement.setAttribute('data-hidden', 'false');
          }
        }

        const closeButton = clone.querySelector('[data-type="close"]');

        if (closeButton) {
          closeButton.addEventListener('click', this.close.bind(this));
          closeButton.addEventListener('keydown', e => {
            if (e.key === 'Enter') this.close();
          });
        }
      }

      this.adjustTopPosition();

      const content = this.querySelector('.cart-popup__content');

      if (!content) return;

      content.innerHTML = '';
      content.append(clone);

      this.addButtonEffect();
      this.open();
      this.getCartSize();
    }

    addButtonEffect() {
      this.querySelectorAll(
        '.custom-btn, .shopify-payment-button__button--unbranded, .cart-dynamic-checkout-buttons div[role=button]'
      ).forEach(item => {
        if (item.getAttribute('data-effect') === 'wave') {
          const svgString = `
            <svg class="editorial"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 24 150 28"
              preserveAspectRatio="none"
              width="200px">
              <defs>
                <path id="gentle-wave"
                  d="M-160 44c30 0 68-18 88-18s
                  68 18 88 18 68-18 88-18
                  68 18 88 18v44h-352z">
                </path>
              </defs>
              <g class="parallax">
                <use xlink:href="#gentle-wave"
                  x="40" y="10" fill="#ffffff"></use>
                <use xlink:href="#gentle-wave"
                  x="30" y="10" fill="#ffffff"
                  fill-opacity="0.2"></use>
              </g>
            </svg>`;

          const parser = new DOMParser();
          const svgElement = parser.parseFromString(
            svgString,
            'image/svg+xml'
          ).documentElement;

          const svgClone = svgElement.cloneNode(true);

          if (!item.querySelector('svg')) {
            item.appendChild(svgClone);
          }
        }

        item.addEventListener('click', function(event) {
          const ripple = document.createElement('span');
          ripple.classList.add('wave-ripple');

          const rect = this.getBoundingClientRect();
          const size = Math.max(rect.width, rect.height);
          const x = event.clientX - rect.left - size / 2;
          const y = event.clientY - rect.top - size / 2;

          ripple.style.width = ripple.style.height = `${size}px`;
          ripple.style.left = `${x}px`;
          ripple.style.top = `${y}px`;

          this.appendChild(ripple);

          ripple.addEventListener('animationend', () => {
            ripple.remove();
          });
        });
      });
    }

    getCartSize() {
      const cartItemsIconUrl = '/?section_id=header-cart-icon';

      fetch(cartItemsIconUrl)
        .then(res => {
          if (!res.ok) {
            throw new Error(res.status);
          }

          return res.text();
        })
        .then(text => {
          const documentFragment = new DOMParser().parseFromString(
            text,
            'text/html'
          );

          const resultsElement = documentFragment.querySelector(
            '#shopify-section-header-cart-icon'
          );

          const cartCount = document.querySelector(
            'custom-header .nav-item .cart-count'
          );

          if (resultsElement && cartCount) {
            cartCount.innerHTML = resultsElement.innerHTML.trim();
            cartCount.setAttribute('data-hidden', 'false');
          }
        });
    }

    close() {
      this.setAttribute('data-hidden', 'true');

      const header = document.querySelector('custom-header');

      if (header) {
        header.setAttribute('data-open-cart-popup', 'false');
      }

      if (this.previouslyFocusedElement) {
        setTimeout(() => {
          this.previouslyFocusedElement.focus();
        }, 100);
      }
    }

    open() {
      this.setAttribute('data-hidden', 'false');

      if (this.querySelector('.heading-wrapper')) {
        setTimeout(() => {
          this.querySelector('.heading-wrapper').focus();
        }, 100);
      }

      if (this.setTimeoutRunning) {
        clearTimeout(this.popupSetTimeout);
      }

      this.setTimeoutRunning = true;

      this.popupSetTimeout = setTimeout(() => {
        this.close();
        this.setTimeoutRunning = false;
      }, this.popupDuration);

      const header = document.querySelector('custom-header');

      if (header) {
        header.setAttribute('data-open-cart-popup', 'true');
      }
    }
  }

  customElements.define('custom-cart-popup', CustomCartPopup);
}
